import React from 'react';
import Layout from '../components/layout/Layout';
import HeroPage from '../components/common/HeroPage';
import { Link } from 'react-router-dom';
import Icon from '../components/common/Icon';
import SectionHeader from '../components/common/SectionHeader';

const campaigns = [
  { 
    id: 'casa-studenti',
    title: 'La Casa è un Diritto', 
    status: 'Attiva',
    badge: 'Mobilizzazione Nazionale',
    excerpt: 'Basta canoni insostenibili. Chiediamo investimenti pubblici negli studentati e tetti agli affitti.',
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=800&auto=format&fit=crop'
  },
  { 
    id: 'salario-minimo',
    title: 'Salario Minimo Subito', 
    status: 'In corso',
    badge: 'Raccolta Firme',
    excerpt: 'Sotto i 9 euro non è lavoro, è sfruttamento. Firma la nostra proposta di legge di iniziativa popolare.',
    image: 'https://images.unsplash.com/photo-1540317580384-e5d43616b9aa?q=80&w=800&auto=format&fit=crop'
  },
  { 
    id: 'salute-mentale',
    title: 'Chiedere Aiuto è un Segno di Forza', 
    status: 'Attiva',
    badge: 'Campagna Sensibilizzazione',
    excerpt: 'Vogliamo uno psicologo di base in ogni distretto sanitario e il potenziamento dei consultori.',
    image: 'https://images.unsplash.com/photo-1527137342181-19aab11a8ee1?q=80&w=800&auto=format&fit=crop'
  }
];

const CampagnePage = () => {
  const breadcrumbs = [{ label: 'Home', path: '/' }, { label: 'Campagne' }];
  
  return (
    <Layout>
      <HeroPage 
        breadcrumbs={breadcrumbs} 
        overline="Mobilitazioni" 
        title="Campagne" 
        subtitle="Le battaglie che portiamo nelle piazze, nelle scuole e nelle università per cambiare l'Italia." 
      />
      
      <section className="section">
        <div className="container">
          <SectionHeader overline="In evidenza" title="Campagne Attive" className="mb-10" />
          <div className="grid grid-2 gap-10">
            {campaigns.map((camp, idx) => (
              <Link 
                to={`/campagna?id=${camp.id}`} 
                key={camp.id}
                className="reveal reveal--scale"
                style={{ 
                  textDecoration: 'none', 
                  color: 'inherit',
                  display: 'flex',
                  flexDirection: 'column',
                  background: '#fff',
                  borderRadius: 'var(--radius-3xl)',
                  overflow: 'hidden',
                  boxShadow: 'var(--shadow-lg)',
                  '--delay': `${idx * 0.1}s`
                }}
              >
                <div style={{ height: '300px', overflow: 'hidden', position: 'relative' }}>
                  <img src={camp.image} alt={camp.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  <div style={{ position: 'absolute', top: '20px', left: '20px' }}>
                    <span className="badge" style={{ background: 'var(--color-primary)', color: '#fff', border: 'none' }}>{camp.status}</span>
                  </div>
                </div>
                <div style={{ padding: 'var(--space-10)' }}>
                  <span className="text-small font-bold text-primary mb-2 block">{camp.badge}</span>
                  <h3 className="h2 mb-4">{camp.title}</h3>
                  <p className="text-body text-secondary mb-8">{camp.excerpt}</p>
                  <div className="flex items-center justify-between mt-auto">
                    <span className="btn btn--outline btn--sm">Partecipa ora</span>
                    <span className="text-primary font-bold flex items-center gap-2">Scopri di più <Icon name="ArrowRight" size={18} /></span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
      
      <section className="section bg-dark" style={{ color: '#fff' }}>
        <div className="container text-center">
          <div className="reveal">
            <h2 className="h1 mb-6">Hai un'idea per una mobilitazione?</h2>
            <p className="text-body-lg mb-10 opacity-80 max-w-2xl mx-auto">
              Le nostre campagne nascono dal basso. Se vuoi proporre un'iniziativa nel tuo territorio o a livello nazionale, mettiti in contatto con noi.
            </p>
            <Link to="/contatti" className="btn btn--primary btn--lg btn--glow">Contattaci</Link>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default CampagnePage;
